import React, { useMemo, useState } from 'react';
import classes from './styles.module.scss';

export default function RedeemNotifs() {
  const redeemNotification = process.env.REACT_APP_MAINTENANCE_MODE;
  /**
   * @type {{title: string, subTitle: string, iconUrl: string, status: string}}
   */
  const appStatus = useMemo(() => {
    try {
      const jsonData = JSON.parse(redeemNotification);
      if (jsonData?.status !== 'notOK') return null;
      return jsonData;
    } catch (error) {
      return null;
    }
  }, [redeemNotification]);

  if (!appStatus) return null;

  return (
    <div className={classes.SikkaProDownloadRow}>
      <div className={classes.logo}>
        {/*random placeholder image url */}
        <img
          src={appStatus?.iconUrl}
          alt="maintainance"
          className={classes.image}
        />
      </div>
      <div className={classes.content}>
        <div className={classes.title}>{appStatus?.title}</div>
        <div className={classes.subtitle}>{appStatus?.subTitle}</div>
      </div>
    </div>
  );
}
